import { useCallback } from 'react';
import { useSlider } from '@trinity/chat-components/components/Slider/hooks/useSlider';
import { useAudioPlayerState } from '@trinity/chat-components/containers/AudioPlayer/Context';
import styles from './style/Progress.Track.module.css';
import { ActiveSliderTrack, InactiveSliderTrack } from '@trinity/chat-components/components/Slider/Tracks';
import { SliderThumb } from '@trinity/chat-components/components/Slider/Thumb';

type Props = {
  scan: (time: number) => void;
  seek: (time: number) => void;
  position: number;
  className?: string;
};

export const AudioPlayerTrackProgress = ({ position, scan, seek, className }: Props) => {
  const [{ duration }] = useAudioPlayerState();

  const handlePositionChange = useCallback((p: number) => {
    scan(p);
  }, [scan]);

  const handleDragEnd = useCallback(() => {
    seek(position);
  }, [seek, position]);

  const {
    activeTrackStyles,
    handleMouseDown,
    handleTouchStart,
    thumbStyles,
    sliderRef,
    thumbRef,
  } = useSlider({
    incrementBy: .05,
    minValue: 0,
    maxValue: duration,
    onDragEnd: handleDragEnd,
    onPositionChange: handlePositionChange,
    value: position,
  });

  return (
    <div
      className={`${styles.track} ${className || ''}`}
      ref={sliderRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}>
      <ActiveSliderTrack
        className={styles.active}
        style={activeTrackStyles} />
      <InactiveSliderTrack
        className={styles.inactive} />
      <SliderThumb
        ref={thumbRef}
        className={styles.thumb}
        style={thumbStyles} />
    </div>
  );
};

export default AudioPlayerTrackProgress;